// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4446":"css/app.6733","4743":"css/admin-app.6733"}[chunkId] + ".css";
};